import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components';

import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';
import CheckboxGroup from '../CheckboxGroup';

import {
    Container,
    ButtonGroupWrapper,
    MultipleGroupFull
} from '../../containers/DefaultStyles/FormDetails';

import { validateStep4 } from './validations';
import { isPortrait } from '../../utils/size';

const minLength = min => value =>
    value && value.length < min ? `Must be ${min} characters or more` : undefined;

const InfoText = styled.span`
    font-size: 12px;
    margin: 0 8px;
    ${() => isPortrait() && `margin-top: 0.5em`};
`;

class VoteRegistrationStep4Form extends React.Component {
    render() {
        return (
            <Container autocomplete="on" onSubmit={this.props.handleSubmit}>
                <MultipleGroupFull style={{ flexDirection: `column` }}>
                    <InfoText>{this.props.infoTextIdNumber}</InfoText>
                    <Field
                        name="idNumber"
                        component={InputGroup}
                        type="text"
                        placeholder="ID Number"
                        label="ID Number"
                        autocomplete="off"
                        maxLength={this.props.maxLengthIdNumber}
                        validate={minLength(this.props.minLengthIdNumber)}
                    />
                </MultipleGroupFull>
                <MultipleGroupFull>
                    <Field
                        style={{ padding: `6px 0` }}
                        name="firstRegistration"
                        component={CheckboxGroup}
                        label="First registration"
                        normalize={v => !!v}
                    />
                </MultipleGroupFull>
                <MultipleGroupFull>
                    <Field
                        style={{ padding: `6px 0` }}
                        name="hasMailingAddress"
                        component={CheckboxGroup}
                        label="I get my mail at a different mailing address"
                        normalize={v => !!v}
                    />
                </MultipleGroupFull>
                <MultipleGroupFull>
                    <Field
                        style={{ padding: `6px 0` }}
                        name="changeOfName"
                        component={CheckboxGroup}
                        label="I have changed my name"
                        normalize={v => !!v}
                    />
                </MultipleGroupFull>
                <MultipleGroupFull>
                    <Field
                        style={{ padding: `6px 0` }}
                        name="changeOfAddress"
                        component={CheckboxGroup}
                        label="I have changed my address"
                        normalize={v => !!v}
                    />
                </MultipleGroupFull>
                <ButtonGroupWrapper>
                    <TwoGroup>
                        {this.props.isOnlineRegistrationAvailable && (
                            <Button label="Back" onClick={this.props.onBack} />
                        )}
                        <Button
                            primary={true}
                            type="submit"
                            label="Continue"
                            disabled={this.props.invalid}
                        />
                    </TwoGroup>
                </ButtonGroupWrapper>
            </Container>
        );
    }
}

VoteRegistrationStep4Form.propTypes = {
    onBack: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func,
    infoTextIdNumber: PropTypes.string,
    maxLengthIdNumber: PropTypes.number,
    minLengthIdNumber: PropTypes.number,
    isOnlineRegistrationAvailable: PropTypes.bool
};

export default compose(
    connect(() => ({
        initialValues: {}
    })),
    reduxForm({
        form: 'voteRegistrationStep4Form',
        validate: validateStep4,
        destroyOnUnmount: false
    })
)(VoteRegistrationStep4Form);
